import { useQuery } from '@tanstack/react-query';
import { getSupabase } from '../supabase';
import type { SharedProfileData } from '../types/shared-profile';

export type { SharedProfileData } from '../types/shared-profile';

export function useSharedProfile(userId?: string | null) {
  const query = useQuery({
    queryKey: ['shared-profile', userId],
    queryFn: async () => {
      const sb = getSupabase();
      const { data, error } = await sb
        .from('profiles')
        .select('opp_avatar_url, opp_username, opp_bio, opp_op_code, avatar_url, display_name, username, bio, banner_url')
        .eq('id', userId!)
        .maybeSingle();

      if (error) throw error;
      return (data ?? null) as SharedProfileData | null;
    },
    enabled: !!userId,
    staleTime: 60_000,
  });

  return {
    ...query,
    refreshProfile: query.refetch,
  };
}
